import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export const ModulePlaceholder = ({ title, description, moduleCode }) => {
  const { user } = useAuth();
  const location = useLocation();

  return (
    <div className="lis-module-container">
      <div className="lis-module-header">
        <div className="lis-breadcrumbs">
          <span>Home</span> &gt; <span>{title}</span>
        </div>
        <h1 className="lis-page-title">{title}</h1>
        <p className="lis-page-desc">{description}</p>
      </div>

      <div className="lis-placeholder-card">
        <div className="lis-placeholder-badge">
          <span>Module Status: Registered & Protected</span>
        </div>
        <p className="lis-placeholder-text">
          This endpoint (<code>{location.pathname}</code>) is fully guarded by the Phase-6 Authentication & Authorization security foundation.
        </p>
        <div className="lis-placeholder-meta">
          <span>Current Operator: <strong>{user?.employeeName}</strong></span>
          <span>Role: <strong>{user?.roleName}</strong></span>
          <span>Centre: <strong>{user?.centreName} ({user?.centreCode})</strong></span>
        </div>
      </div>
    </div>
  );
};

export default ModulePlaceholder;
